import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XDiv, XText } from "IZOX/_X";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class StepperM extends Component {

  static propTypes = {
    curStep: PropsType.number,
    steps: PropsType.array,
    onStepChange: PropsType.func,
    stepWidth: PropsType.number
  }

  static defaultProps = {
    curStep: 0,
    steps: [],
    onStepChange: null,
    stepWidth: 120,
    barWidth: 40
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(StepperM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderStep(step, idx){
    let {curStep, onStepChange, stepWidth, barWidth} = this.props;
    let isStepOver = idx <= curStep;
    return (
      <XButton onPress={() => onStepChange?.(idx)} key={idx}
        width={stepWidth} style={{overflow: "visible"}}>
        {idx > 0 && <XDiv bColor={ColorX.CSS(isStepOver ? "Axit" : "Gray4")}
          width={barWidth} height={2} bW={1}
          style={{bottom: 20, right: 74}} position="absolute"/>}
        <VStack fullWidth overflow="visible">
          <HStack height={50} VAlign="^">
            <XText fontSize={12} color={ColorX.CSS(isStepOver ? "Axit" : "Gray4")} bold textAlign="|">
              {LocaleX.Parse(step)}
            </XText>
          </HStack>
          <XDiv bgColor={ColorX.CSS(isStepOver ? "Axit" : "Gray4")} round={50}
            width={24}>
            <XText color={ColorX.CSS("pureWhite")} fontSize={15}
              textAlign="|">
              {String(idx + 1)}
            </XText>
          </XDiv>
        </VStack>
      </XButton>
    );
  }

  render(){
    let {steps} = this.props;
    return (
      <HStack justifyContent="space-between" pV={10}>
        {_.map(steps, (o, i) => {
          return this.renderStep(o, i); 
        })}
      </HStack>
    );
  }

}

export default observer(StepperM);
